import React, { useState, useRef, useContext, useEffect } from "react";
import Image from "react-bootstrap/Image";
import Logo from "../../images/logocolor.png";
import Logo2 from "../../images/therapist_logo.png";
import Form from "react-bootstrap/Form";

import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import LoginBg from "../../images/newimg/login.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../../../utility/services/ApiService";
import Functions from "../../../utility/services/Functions";
import { AuthContext } from "../../../utility/services/AuthContext";
import { trackEvent } from "../../../utility/services/analyticsService";
import Modal from "react-bootstrap/Modal";
import SuccessIcon from "../../images/pending.svg";

const Otp = () => {
  // FUNCTIONAL VARIABLES

  const location = useLocation();
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];
  const navigate = useNavigate();

  const { consoleService, enctyptDataFun } = Functions();
  const { manual_login, send_otp } = ApiService();
  const { setLoading, setUser, user, authUserRole } = useContext(AuthContext);

  const [show_delete_info_modal, setShowDeleteInfoModal] = useState(false);
  const [delete_info_modal_text, setDeleteInfoModalText] = useState("");

  const [modalShow, setModalShow] = React.useState(false);

  const alertRef = useRef(false);

  const isRoleTherapist = authUserRole == "Therapist";

  // DATA VARIABLES

  const phone = location.state?.phone;
  const otp = otpValues.join("");

  // USE EFFECTS

  useEffect(() => {
    if (!authUserRole) return navigate("/", { replace: true });
    if (alertRef.current) return;
    alertRef.current = true;
  }, []);
  ///////////////////////////////////////// FUNCTIONS   //////////////////////////////////

  const handleInputChange = (index, value) => {
    const ModifiedValue = value.replace(/[^0-9]/g, ""); // Allow only numbers

    const newOtpValues = [...otpValues];
    newOtpValues[index] = ModifiedValue;
    setOtpValues(newOtpValues);

    // Auto-focus on the next input
    if (ModifiedValue !== "" && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to the previous input on backspace
    if (e.key === "Backspace" && index > 0 && otpValues[index] === "") {
      inputRefs[index - 1].current.focus();
    }
  };

  const handel_delete_status = (message) => {
    setDeleteInfoModalText(message);
    setShowDeleteInfoModal(true);
  };

  const submit_fun = async () => {
    setLoading(true);
    try {
      const data = {
        role: authUserRole,
        phone,
        otp,
        device_token: "",
      };
      const res = await manual_login(data);
      if (res.status === 1) {
        setOtpValues(["", "", "", ""]);
        const { isUser, profile_approve_status, is_profile_submitted } =
          res.data;
        if (authUserRole == "Therapist") {
          if (!isUser) {
            navigate("/therapistregisteration", {
              state: { phone, navigateFrom: "otp_screen" },
              replace: true,
            });
          } else if (isUser && !is_profile_submitted && !is_profile_submitted) {
            navigate("/therapistcompleteprofile", {
              state: res.data.user_id,
              replace: true,
            });
          } else if (
            isUser &&
            !profile_approve_status &&
            is_profile_submitted
          ) {
            setModalShow(true);
          } else {
            localStorage.setItem("E_C_U_A_T", enctyptDataFun(res.data.token));
            trackEvent("login", { event_type: "logged_in", method: "phone", user_role: authUserRole, phone });
            setUser({ ...user, access_token: res.data.token });
            navigate("/dashboard", { replace: true });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        } else {
          if (!isUser) {
            navigate("/patientregisteration", {
              state: {
                phone,
                navigateFrom: "otp_screen",
              },
              replace: true,
            });
          } else {
            localStorage.setItem("E_C_U_A_T", enctyptDataFun(res.data.token));
            trackEvent("login", { event_type: "logged_in", method: "phone", user_role: authUserRole, phone });
            setUser({ ...user, access_token: res.data.token });
            navigate("/dashboard", { replace: true });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        }
      } else if (res.status === 2) {
        handel_delete_status(res.message);
      } else {
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      consoleService("error in send otp function", err);
    }
  };

  const resend_otp_function = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      await send_otp({ phone, role: authUserRole });
      setOtpValues(["", "", "", ""]);
      toast("Otp Sent Successfully.", {
        position: "top-center",
        hideProgressBar: true,
        type: "success",
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      consoleService("error in resend otp function", err);
    }
  };

  // NESTED COMPONENT

  function AccountDeleteInfoModel(props) {
    const isRoleTherapist = authUserRole == "Therapist";
    const isRolePatient = authUserRole == "Patient";
    const naviage_fun = () => {
      if (isRoleTherapist) {
        setShowDeleteInfoModal(false);
        navigate("/therapistregisteration", {
          state: { phone, navigateFrom: "otp_screen" },
          replace: true,
        });
      } else if (isRolePatient) {
        setShowDeleteInfoModal(false);
        navigate("/patientregisteration", {
          state: { phone, navigateFrom: "otp_screen" },
          replace: true,
        });
      }
    };
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <p>{delete_info_modal_text}</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="delete_acc_info_modal">
            <Button
              onClick={() => {
                naviage_fun();
              }}
            >
              OK
            </Button>
            <Button
              as={Link}
              onClick={() => {
                setShowDeleteInfoModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal(props) {
    const { navigate } = props;
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Approval Pending</h4>
          <p>
            Your account is pending for approval, We will check your details and
            let you know the status of your account shortly.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModalShow(false);
              navigate("/", { replace: true });
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <>
      <section
        className="loginBg"
        style={{ backgroundImage: `url(${LoginBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Form>
                <div className="loginBox loginOtpBox">
                  <div className="text-center">
                    <Link to="/">
                      <Image
                        src={isRoleTherapist ? Logo2 : Logo}
                        className="logo"
                        alt=""
                      />
                    </Link>
                    <h1>Enter OTP</h1>
                    <p>Enter the OTP sent to the number provided by you</p>
                  </div>
                  <h4>
                    OTP has been sent to <span>{phone}</span>
                  </h4>
                  <h5>
                    If this number is not correct{" "}
                    <Link to="/login">Edit Here</Link>
                  </h5>
                  <div className="formOtp mb-3">
                    {otpValues.map((value, index) => (
                      <Form.Group
                        key={index}
                        controlId={`exampleForm.ControlInput${index}`}
                      >
                        <Form.Control
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]"
                          maxLength={1}
                          placeholder=""
                          value={value}
                          onChange={(e) =>
                            handleInputChange(index, e.target.value)
                          }
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              otp.length == 4 && submit_fun();
                            } else {
                              handleKeyDown(index, e);
                            }
                          }}
                          ref={inputRefs[index]}
                        />
                      </Form.Group>
                    ))}
                  </div>

                  <div
                    className="conguest"
                    onClick={(e) => {
                      resend_otp_function(e);
                    }}
                  >
                    Resend Code
                  </div>
                  <Button
                    disabled={otp.length !== 4}
                    onClick={() => {
                      submit_fun();
                    }}
                    // as={Link}
                    // to="/therapistregisteration"
                    className="btn btn-primary me-3"
                  >
                    Submit
                  </Button>

                  <div className="links_box mt-3">
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/termsofservice", "_blank");
                      }}
                    >
                      Terms of Service
                    </Link>
                    <span>|</span>
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/privacypolicy", "_blank");
                      }}
                    >
                      Privacy Policy
                    </Link>
                    <span>|</span>
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/hipaa");
                      }}
                    >
                      HIPAA
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
      <MyVerticallyCenteredModal
        navigate={navigate}
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          navigate("/", { replace: true });
        }}
      />
      <AccountDeleteInfoModel show={show_delete_info_modal} />
    </>
  );
};

export default Otp;
